import { useEffect, useRef } from "react";
import { Animated } from "react-native";
 
const SHIMMER_DURATION = 1200;
 
export function useShimmer() {
  const anim = useRef(new Animated.Value(0)).current;
 
  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(anim, {
          toValue: 1,
          duration: SHIMMER_DURATION,
          useNativeDriver: true,
        }),
        Animated.timing(anim, {
          toValue: 0,
          duration: SHIMMER_DURATION,
          useNativeDriver: true,
        }),
      ])
    ).start();
  }, [anim]);
 
  return anim;
}